import React from 'react';
import './PolicyAgrarianismDescription.css';
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import {SUPPLY_COLOR} from "../../../../styles/constants";
import PlayerStat from "../../../PlayerStat/PlayerStat";
import {POLICY_AGRARIANISM_BUILDING_DISCOUNT_WAREHOUSE} from "../../../../configs/policy/agrarianism";

const PolicyAgrarianismDescription = () => {
  const freeAction = <img
    className={'policy-description-icon policy-description-icon-margin-right'}
    src={'/img/icons/free action.png'}
    alt={'Свободное действие'}
    title={'Свободное действие (не учитывается лимитом действий в Фазе Строительства)'}
  />;

  const hammer = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/hammer brown.png'}
    alt={'Строительство'}
    title={'Строительство'}
  />;

  const farm = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-min'}
    src={'/img/hexes/farm.699e6dfc.png'}
    alt={'Ферма'}
    title={'Ферма'}
  />;

  const warehouse = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/hexes/special buildings/warehouse.adf397b3.png'}
    alt={'Склад'}
    title={'Склад'}
  />;

  const discountElement = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/percent white.png'}
    alt={'Скидка'}
    title={'Скидка'}
  />;

  const buildingDiscount =
    <CoinsStat
      text={POLICY_AGRARIANISM_BUILDING_DISCOUNT_WAREHOUSE}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left'}
    />;

  const supply2 = <PlayerStat
    text={2}
    noShrinkOnMobile={true}
    color={SUPPLY_COLOR}
    icon={'/img/icons/supply.png'}
    className={'supply-stat'}
    title={'Снабжение'}
  />
  const supply3 = <PlayerStat
    text={3}
    noShrinkOnMobile={true}
    color={SUPPLY_COLOR}
    icon={'/img/icons/supply.png'}
    className={'policy-description-icon-margin-left supply-stat'}
    title={'Снабжение'}
  />

  const coins1 =
    <CoinsStat
      text={1}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left'}
    />;

  const coins2 =
    <CoinsStat
      text={2}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left'}
    />;

  const arrow = <img
    className={'from-to-icon policy-description-icon'}
    src={'/img/icons/up.png'}
    alt={'Обменять'}
    title={'Обменять'}
  />;

  return (
    <>
      <div className={'policy-description_line'}>
        {freeAction} В
        <span className={'text-construction policy-description-icon-margin-left-end'}>
          фазе Строительства
        </span>
      </div>
      <div className={'policy-description_line'}>
        можно {hammer} 1 {farm} за {coins2}.
      </div>
      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        {warehouse} дешевле {discountElement} на {buildingDiscount}.
      </div>
      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        В
        <span className={'text-supply policy-description-icon-margin-right-left'}>
          фазе Снабжения
        </span>
        можно:
      </div>
      <div className={'policy-description_line'}>
        {supply2}{arrow}{coins1}, {supply3}{arrow}{coins2}.
      </div>
    </>
  );
};

export default PolicyAgrarianismDescription;
